/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class ThorSoundConfig implements ISoundConfig {

    public static instance:ThorSoundConfig = new ThorSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string = "background-music-main";
    FS_GAME_AMBIANCE:string = "background-music-fs";
    COUNTUP:string = "countup";
    COUNTUP_ENDS:string = "countupEnds";
    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";
    BONUS_HAMMER_HIT:string = "bonusHammerHit";
    BONUS_ICON_SELECTED:string = "bonusSymbolLightUpFinal";
    BONUS_LANDING:string = "bonusLanding";
    BONUS_ICON_SELECT:string = "bonusSymbolLightUp";
    BONUS_LIGHTNING_01:string = "bonusLightning1";
    BONUS_LIGHTNING_02:string = "bonusLightning2";
    BONUS_CHAINS:string = "bonusChains";
    BONUS_NUDGE:string = "bonusNudge";
    BONUS_EXTRA_FS:string = "bonusPlusSpins";
    SCATTER_LANDING:string = "scatter";
    SCATTER_CRACK:string = "scatterCrack";
    SCATTER_METER_UP:string = "meterUp";
    SCATTER_NUDGE:string = "scatterNudge";
    ASGARD_WIN:string = "fsWin";
    BIG_WIN:string = "bigwin";
    BIG_WIN_END_01:string = "bigwinEnds1";
    BIG_WIN_END_02:string = "bigwinEnds2";
    BIG_WIN_END_03:string = "bigwinEnds3";
    HAMMERTIME_START:string = "randomHammerTime";
    RUNE_RAZE_START:string = "randomRuneRaze";
    RUNE_RAZE_RUNE_SELECT:string = "randomRuneRazeLightUp";
    NEAR_WIN_START:string = "anticipation";
    NEAR_WIN_STOPP:string = "anticipationStop";
    ELECTRIC_LOOP:string = "bonusShake";
    BIG_WIN_INITIAL_WIN:string = "bigwinInitialWin";

    FS_INTRO:string = "fsIntro";
    FS_OUTRO:string = "fsOutro";



    // REELS_SPIN_START?:string[];
    // REELS_SPINNING:string = "reelsSpinning";
    REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    // REELS_DEFAULT_STOP?:string[];

    constructor() {
        if(ThorSoundConfig.instance) {
            throw new Error("ThorSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}